import React, { useContext, useEffect, useMemo, useState } from 'react'
import GenericStepper from '../../../components/GenericStepper/GenericStepper'
import Gateways from './Steps/Gateways';
import PerfilDispositivo from './Steps/PerfilDispositivo';
import Aplicacoes from './Steps/Aplicacoes';
import Dispositivos from './Steps/Dispositivos';
import Redirecionamentos from './Steps/Redirecionamentos';
import { LnsCadastroRapidoContext } from '../../../contexts/LnsCadastroRapido';
import ReactLoading from "react-loading";
import axios from 'axios'
import auth from '../../../utils/auth';
import cfg from '../../../utils/config'

export default function QuickRegisterContent() {
    const { resetState } = useContext(LnsCadastroRapidoContext);

    const [loadingGateways, setLoadingGateways] = useState(true);
    const [hasGateway, setHasGateway] = useState(false);

    useEffect(() => {
        getGateways();
    }, []);

    const getGateways = async () => {
        try {
            setLoadingGateways(true);

            const config_me = {
                headers: {
                    Authorization: 'Bearer ' + auth.getToken()
                }
            };

            const userInfo = auth.getUserInfo();

            const url = cfg.base_api_url + cfg.api_v2 + '/' + userInfo.empresa + '/lns/gateway/?limit=1';

            const res = await axios.get(url, config_me);

            setHasGateway((res.data.results || []).length > 0);
        } catch (error) {
            setHasGateway(false);
        } finally {
            setLoadingGateways(false);
        }
    };

    const steps = useMemo(() => {
        const baseSteps = [
            {
                titulo: "Aplicações",
                component: Aplicacoes,
            },
            {
                titulo: "Perfis de Dispositivos",
                component: PerfilDispositivo,
            },
            {
                titulo: "Dispositivos",
                component: Dispositivos,
            },
            {
                titulo: "Redirecionamentos",
                component: Redirecionamentos,
            },
        ];

        if (!hasGateway) {
            baseSteps.unshift({
                titulo: "Gateways",
                component: Gateways,
            });
        }

        return baseSteps;
    }, [hasGateway]);

    return (
        <div className="hdv-render-div">
            <div className="hdv-default-header mx-3 d-flex flex-wrap justify-content-between align-items-center gap-2">
                <div className="d-flex align-items-center gap-2">
                    <span className="screen-menu-desc d-flex align-items-center gap-2">
                        <h4 className="mb-0">Cadastro Rápido</h4>

                        <div
                            className="gray-background d-flex align-items-center justify-content-center"
                            style={{ height: "36px", width: "36px" }}
                        >
                            <i className="fa fa-fast-forward fa-2x"></i>
                        </div>
                    </span>
                </div>
            </div>

            {loadingGateways ? (
                <div className="loading-screen-overlay">
                    <ReactLoading type="spin" color="var(--background-menu)" width={40} />
                </div>
            )
                :
                <GenericStepper
                    steps={steps}
                    startTitle="Iniciar o Cadastro Rápido do LNS"
                    finishMessage="Seu cadastro foi concluído com sucesso."
                    allowRestart={true}
                    emitFinish={resetState}
                />
            }
        </div>
    )
}